import type { Nullable } from "../../../typescript"
import type { Player } from "./Player.type"

export default function playerDisplayName (player: Nullable<Player>): Nullable<string> {
  if (player) {
    return player.dname || player.dname_placeholder
  }
}